export const capitalize = (str: string): string => {
    return (str || '').replace(/(\s\w|(^\w))/g, (n) => n.toUpperCase());
  };